module.exports = __webpack_public_path__ + "img/mtn-money-logo.d44833fc.png";